import { create } from 'zustand';
import type { StateCreator } from 'zustand';

interface sparkRunStoreSliceType {
  // collectiveSparkRunIDs: string[];
  // addToSparkRunIDsCollection: (sparkRunID: string) => void;
  selectedSparkRunID: string;
  setSelectedSparkRunID: (sparkRunID: string) => void;
  resetStore: () => void;

  isFormSideBarOpen: boolean;
  toggleFormSidBar: () => void;
  openFormSideBar: () => void;
  closeFormSideBar: () => void;
}

const NULL_INITIAL_STORE_VALUES = {
  collectiveSparkRunIDs: [],
  selectedSparkRunID: '',
  isFormSideBarOpen: false,
};

const sparkRunStoreSlice: StateCreator<sparkRunStoreSliceType> = (
  set,
  get
) => ({
  ...NULL_INITIAL_STORE_VALUES,
  resetStore: () => set(() => NULL_INITIAL_STORE_VALUES),
  // addToSparkRunIDsCollection: (id: string) =>
  //   set((state) => {
  //     if (state.collectiveSparkRunIDs.includes(id)) {
  //       return state;
  //     }
  //     return {
  //       ...state,
  //       collectiveSparkRunIDs: [...state.collectiveSparkRunIDs, id],
  //     };
  //   }),
  setSelectedSparkRunID: (id: string) =>
    set((state) => {
      return {
        ...state,
        selectedSparkRunID: id,
      };
    }),
  openFormSideBar: () =>
    set((state) => ({
      ...state,
      isFormSideBarOpen: true,
    })),
  toggleFormSidBar: () =>
    set((state) => ({
      ...state,
      isFormSideBarOpen: !state.isFormSideBarOpen,
    })),

  closeFormSideBar: () =>
    set((state) => ({
      ...state,
      isFormSideBarOpen: false,
    })),
});

export const useSparkRunStore =
  create<sparkRunStoreSliceType>(sparkRunStoreSlice);
